<app-combobox
  #combobox
  [selectedKey]="exact"
  (selectedKeyChange)="accepts($event)"
  [options]="options"
></app-combobox>
